import { useEffect } from 'react';
import { useElementOnScreen } from '@/hooks/intersectionObserver';
import { SwiperClass } from 'swiper/react';

export function useTestimonialAutoplay() {
  const autoplayTime = 5000;

  const { containerRef, isVisible } = useElementOnScreen({
    root: null,
    rootMargin: '-100px',
    threshold: 0.0,
  });

  useEffect(() => {
    const swiper = containerRef?.current?.swiper as SwiperClass;

    if (!swiper) return;

    if (isVisible) {
      swiper.autoplay.start();
    } else {
      swiper.autoplay.stop();
    }
  }, [isVisible, containerRef]);

  return { autoplayTime, containerRef };
}
